import { Directory, Post } from "./viewerApi";

export function ordered<T extends { order?: number }>(items: T[]): T[] {
    return [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function childrenOf(directories: Directory[], parent: string | null): Directory[] {
    return ordered(directories.filter(directory => !directory.deleted_at
        && (directory.parentSubcategoryUuid || null) === parent));
}

export function descendantIds(directories: Directory[], parent: string): Set<string> {
    const ids = new Set<string>([parent]);
    let pending: string[] = [parent];
    while (pending.length > 0) {
        const next = new Set<string>();
        directories.forEach(directory => {
            if (!directory.deleted_at && pending.includes(directory.parentSubcategoryUuid) && !ids.has(directory.uuid)) {
                next.add(directory.uuid);
                ids.add(directory.uuid);
            }
        });
        pending = [...next];
    }
    return ids;
}

export function postsAtLevel(posts: Post[], directory: string | null): Post[] {
    return posts.filter(post => (post.subcategoryUuid || null) === directory);
}
